import { Table, Modal, Button, } from 'antd';
import { useState } from 'react';
import RemarksComponent from './RemarksComponent';
import { render } from '@testing-library/react';

const PartnerChangeHistory = (props) => {
    const [remarks, setRemarks] = useState(false);
    const [isHistory, setIsHistory] = useState(false)

    const {
        partnerChangeOpen,
        setPartnerChangeOpen,
        partnerChangeData,
        setPartnerChangeData,
        resData,
    } = props

    const handleModalCancel = () => {
        setPartnerChangeOpen(false);
    }

    const handleRemarksModal = () => {
        setRemarks(true);
        setIsHistory(true);
    }

    const columns = [
        {
            title: 'Applicant Name',
            dataIndex: 'applicantName',
            key: 'applicantName',
            align: 'center'
        },
        {
            title: 'LoanNo',
            dataIndex: 'lanNo',
            key: 'lanNo',
            align: 'center'
        },
        {
            title: 'New Partner Name',
            dataIndex: 'newPartnerName',
            key: 'newPartnerName',
            align: 'center'
        },
        {
            title: 'New Partner ID',
            dataIndex: 'newPartnerId',
            key: 'newPartnerId',
            align: 'center'
        },
        {
            title: 'Old Partner Name',
            dataIndex: 'oldPartnerName',
            key: 'oldPartnerName',
            align: 'center'
        },
        {
            title: 'Old Partner ID',
            dataIndex: 'oldPartnerId',
            key: 'oldPartnerId',
            align: 'center',
            render: (text) => { if (text === -1) { return "" } else { return text; } }
        },
        {
            title: 'source By',
            dataIndex: 'sourceBy',
            key: 'sourceBy',
            align: 'center'
        },
        {
            title: 'Remapping User',
            dataIndex: 'createdName',
            key: 'createdName',
            align: 'center'
        },
        {
            title: 'Remapping Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            align: 'center',
            render: (text) => new Date(text).toLocaleDateString()
        },
        {
            title: 'Disbursal Date',
            dataIndex: 'disbDate',
            key: 'disbDate',
            align: 'center'
        },
        {
            title: 'Status',
            dataIndex: 'lanStatus',
            key: 'lanStatus',
            align: 'center',
            render: (_, text) => {
                if (text.remapStageId === 3) {
                    return "Remap Requested"
                } else if (text.remapStageId === 4) {
                    return "Remapped"
                } else return text.lanStatus;
            }
        },
        {
            title: 'Remark',
            dataIndex: 'remarks',
            key: 'remarks',
            align: 'center',
            render: (_, record) => {
                return (
                    <span style={{ maxWidth: "200px", display: "inline-block" }} >{record.remarks}</span>
                )
            }

        },
    ]

    return (
        <>
            <div className="partnerHistory-container">
                <Modal open={partnerChangeOpen} width={1200} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleModalCancel}>
                    <Table style={{ marginTop: "20px" }} dataSource={partnerChangeData} columns={columns}></Table>
                </Modal>
            </div>
            <RemarksComponent
                resData={resData}
                remarks={remarks}
                setRemarks={setRemarks}
                isHistory={isHistory}
                setIsHistory={setIsHistory}
            />
        </>
    )


}


export default PartnerChangeHistory;